import React from 'react';
import PropTypes from 'prop-types';
import {
  Table, Dropdown, Icon, Checkbox,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import { formatProductCell } from '../../utilities/productUtil';

const ListRow = (actionHandler, bulkSelectHandler, isEligibleForBulkUpdate) => {
  const Row = ({
    id,
    vehicleFullDescription,
    purchasePrice,
    guaranteePrice,
    ifBid,
    updatedAt,
    emails,
    pendingReasonNotice,
    auctionInformation: {
      auctionAccessNumber,
      dealerNumber,
      universalNumber,
    },
    vehicleInformation: { odometerReading, vin },
    guaranteePurchaseId,
    guaranteeStatus,
    product,
  }) => {
    const notPending = guaranteeStatus !== 'pending';
    const rowMenuOptions = [
      { key: 1, text: 'Details', value: 'Details' },
      {
        key: 3, text: 'Allow', value: 'Allow', disabled: notPending,
      },
      { key: 4, text: 'Update ODS Attributes', value: 'UpdateOdsAttributes' },
    ];

    const handleActionChange = (e, { value }) => {
      e.preventDefault();
      actionHandler(value, {
        id,
        vehicleFullDescription,
        purchasePrice,
        guaranteePrice,
        ifBid,
        updatedAt,
        emails,
        pendingReasonNotice,
        auctionInformation: {
          auctionAccessNumber,
          dealerNumber,
          universalNumber,
        },
        vehicleInformation: { odometerReading, vin },
        guaranteePurchaseId,
        guaranteeStatus,
      });
    };

    const handleCheckboxchange = e => {
      e.preventDefault();
      bulkSelectHandler(id, guaranteePurchaseId);
    };
    const formatedEmails = isEmpty(emails)
      ? null
      : `${emails.replace(/,/g, ', ')}`;

    return (
      <Table.Row key={id}>
        <Table.Cell>
          <Checkbox
            checked={isEligibleForBulkUpdate}
            onChange={handleCheckboxchange}
          />
        </Table.Cell>
        <Table.Cell>{dealerNumber}</Table.Cell>
        <Table.Cell>{auctionAccessNumber}</Table.Cell>
        <Table.Cell>{universalNumber}</Table.Cell>
        <Table.Cell>{vin}</Table.Cell>
        <Table.Cell>{vehicleFullDescription}</Table.Cell>
        <Table.Cell>{guaranteeStatus}</Table.Cell>
        <Table.Cell data-testid='product-cell'>
          {formatProductCell(product?.name)}
        </Table.Cell>
        <Table.Cell>{purchasePrice}</Table.Cell>
        <Table.Cell>{odometerReading}</Table.Cell>
        <Table.Cell>{guaranteePrice}</Table.Cell>
        <Table.Cell>{updatedAt}</Table.Cell>
        <Table.Cell>{formatedEmails}</Table.Cell>
        <Table.Cell>{pendingReasonNotice}</Table.Cell>
        <Table.Cell>
          {ifBid && <Icon color='green' name='checkmark' size='large' />}
          {!ifBid && <Icon color='red' name='close' size='large' />}
        </Table.Cell>

        <Table.Cell>
          <Dropdown
            text='Actions'
            options={rowMenuOptions}
            icon='ellipsis horizontal'
            onChange={handleActionChange}
            inline
            item
            selectOnBlur={false}
            value={null}
          />
        </Table.Cell>
      </Table.Row>
    );
  };

  Row.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vehicleFullDescription: PropTypes.string,
    purchasePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    guaranteePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ifBid: PropTypes.bool,
    updatedAt: PropTypes.string,
    emails: PropTypes.string,
    pendingReasonNotice: PropTypes.string,
    auctionInformation: PropTypes.shape({
      auctionAccessNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dealerNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      universalNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    vehicleInformation: PropTypes.shape({
      odometerReading: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      vin: PropTypes.string,
    }),
    guaranteePurchaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    guaranteeStatus: PropTypes.string,
    product: PropTypes.shape({
      name: PropTypes.string,
    }),
  };

  return Row;
};

export default ListRow;
